import { Signal } from 'typed-signals';
import type { TileStackModel } from '../board/TileStackModel';
import { generateId } from '../../../../utils/generateId';
import type { BlockerMatchParams, BlockerModel, StarBlockerState } from '../../types';
import { BlockerType } from '../../types';

export class StarBlockerModel implements BlockerModel {
  public readonly underTile = true;

  public readonly onModelChanged = new Signal();

  public readonly requestRemoval = new Signal();

  public destructible = false;

  private readonly state: StarBlockerState = {
    type: BlockerType.Star,
  };

  public readonly id = generateId('star');

  constructor(private readonly stack: TileStackModel) {}

  public exportState(): StarBlockerState {
    return this.state;
  }

  public getType(): BlockerType {
    return this.state.type;
  }

  public onMatch({ stack }: BlockerMatchParams): void {
    if (this.stack !== stack) return;
    this.requestRemoval.emit();
  }
}
